<template>
  <div class="nos-domaines">
    <img class="bg-filets" src="/images/altela-img/nos-domaines/bg-filets.png" alt="bg-filets"/>
    <div v-if="pageProduct">
      <Breadcrumb :level1="level1" :level2="level2" :level3="level3"/>
    </div>
    <div class="fancy-feature-twelve md-pt-50" id="about">
      <div class="bg-wrapper d-flex justify-content-between align-items-center flex-sm-row flex-column"
           :class="{ 'no-mg-b': noMb }">
        <div class="container">
          <h3 class="titleNosDomaines" :class="{ 'text-start' : pageProduct }" :style="`color: ${ (productFamily?.color) ? productFamily.color : '#D9000D' }`">{{ title }}</h3>
          <div class="row justify-content-center md-pt-20 textWelcome">
            <p v-if="p1" :class="{ 'text-center' : textCenter }">
              {{ p1 }}
            </p>
            <p v-if="p2" :class="{ 'text-center' : textCenter }">
              {{ p2 }}
            </p>
            <hr v-if="hr">
            <p v-if="p3" :class="{ 'text-center' : textCenter }">
              {{ p3 }}
            </p>
            <p class="bold" v-if="pBold" :class="{ 'text-center' : textCenter }">{{ pBold }}</p>
          </div>
        </div>
        <div class="welcomeImg" :class="{ 'pageProduct': pageProduct }" v-if="welcomeImg">
          <img :src="`/images/altela-img/${welcomeImg}`" alt=""/>
        </div>
      </div>
    </div>
    <div v-if="detailProduct" class="detailProduct">
      <Products :listProducts="product" :detailProduct="detailProduct"/>
    </div>
  </div>
</template>
<script setup>
import Breadcrumb from "@/components/altela/Breadcrumb/index.vue"
import Products from "@/components/altela/Products/index.vue"
import ProductData from "@/public/static/menu.json"

const route = useRoute()

 const props = defineProps({
  title: String,
  welcomeImg: String,
  p1: String,
  p2: String,
  p3: String,
  pBold: String,
  textCenter: Boolean,
  hr: Boolean,
  pageProduct: Boolean,
  noMb: Boolean,
  detailProduct: Boolean,
  level1: String,
  level2: String,
  level3: String,
})

const title = ref('')
const p1 = ref('')
const level1 = ref('')
const level2 = ref('')
const level3 = ref('')

const productFamily = ProductData.filter((elm) => {
  return elm.id === parseInt(route.params.idMenu ?? '')
})[0]

const productCategory = productFamily?.menu?.filter((elm) => {
  return elm.id === parseInt(route.params.idSubMenu ?? '')
})[0]

const product = productCategory?.menuItem?.filter((elm) => {
  return elm.id === parseInt(route.params.id ?? '')
})


title.value = (props.detailProduct) ? productCategory.title : props.title
p1.value = (props.detailProduct) ? productFamily.describe : props.p1
level1.value = (props.detailProduct) ? productFamily.name : props.level1
level2.value = (props.detailProduct) ? productCategory.title : props.level2
level3.value = (props.detailProduct) ? product[0].title : props.level3

</script>
<style scoped>

#about {
  margin-top: 3rem;
}

.nos-domaines {
  position: relative;
  overflow: hidden;
  //padding-top: 2rem
}

.bg-filets {
  position: absolute;
  top: -60%;
  opacity: 0.1;
  width: 100%;
  height: auto;
  object-fit: cover;
  z-index: -1;
}

.container {
  max-width: 1450px;
  //max-width: 1650px;
  padding: 3.75rem;
  border-radius: 0.625rem;
  background: #FFF;
  box-shadow: 0 11px 27px 0 rgba(0, 0, 0, 0.19);
  //display: flex;
}

.titleNosDomaines {
  text-align: center;
  font-size: 39px;
  font-family: Panton;
  text-transform: uppercase;
  font-style: italic;
  color: #D9000D;
  margin-bottom: 2rem;
  //width: 55%;
}

.row {
  row-gap: 3rem;
}

.bg-wrapper {
  margin-bottom: 5rem;
  padding-bottom: 6rem;
  border-bottom: 1px solid #DFDFE4;
  column-gap: 5rem;
  padding-left: 5rem;
}

.textWelcome p {
  color: #003853;
  font-family: Roboto;
  font-size: 1.1875rem;
  font-style: normal;
  line-height: 144%; /* 1.71rem */
}

.textWelcome p:nth-child {
  font-weight: 400;
}

.textWelcome p.bold {
  font-weight: 700;
}

.welcomeImg {
  width: 70%;
  border-radius: 1.25rem 0 0 1.25rem;
  box-shadow: 0 11px 27px 0 rgba(0, 0, 0, 0.19);
}

.welcomeImg img {
  width: 100%;
  max-height: 32rem;
  object-fit: cover;
  border-radius: 1.25rem 0 0 1.25rem;
}

.pageProduct img {
  max-height: 21rem;
}

.no-mg-b {
  margin-bottom: 0 !important;
  border-bottom: none;
}

.detailProduct {
  padding-left: 5rem;
  padding-bottom: 5rem;
  padding-top: 3rem;
}

@media screen and (max-width: 810px) {
  .titleNosDomaines {
    font-size: 20px;
    margin-bottom: 0;
  }

  .nos-domaines {
    padding-top: 0;
  }

  #about {
    margin-top: 0;
    padding-top: 0 !important;
  }

  .bg-wrapper {
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: 2rem;
    margin-bottom: 3rem;
  }

  .container {
    padding: 0.75rem;
  }

  .textWelcome p {
    font-size: 15px;
  }

  .welcomeImg {
    width: 100%;
    margin-top: 2rem;
    border-radius: initial;
  }

  .welcomeImg img {
    border-radius: initial;
  }

  .row {
    row-gap: 1rem;
  }

  .detailProduct {
    padding: 1rem;
  }
}
</style>